import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://customer-assets.emergentagent.com/job_jd-mailer-pro/artifacts/25t7dqsa_Untitled%20design%20%2835%29.png" alt="Aplica" className="h-8 w-8 rounded-md" />
            <span className="font-display font-semibold text-lg">Aplica</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-1.5">
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-6 py-16">
        <span className="label-xs">Legal</span>
        <h1 className="mt-2 text-4xl md:text-5xl font-display tracking-tighter">Terms of Service</h1>
        <p className="mt-3 text-slate-500">Effective Date: 10 Apr, 2026</p>

        <div className="mt-10 space-y-8 text-slate-700 leading-relaxed">
          <p>By using <strong>Aplica</strong>, you agree to the following terms:</p>

          <Section title="1. Use of Service">
            <p>Aplica helps users generate and send job application emails.</p>
            <p className="mt-2">You agree to:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Use the platform legally</li><li>Provide accurate information</li><li>Not misuse or abuse the service</li></ul>
          </Section>

          <Section title="2. User Responsibility">
            <p>You are responsible for:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>The content of emails sent</li><li>Ensuring accuracy of job applications</li><li>Any actions taken using your account</li></ul>
            <p className="mt-2">Aplica is not responsible for hiring outcomes.</p>
          </Section>

          <Section title="3. Email Sending Limits">
            <ul className="list-disc pl-6 space-y-1"><li>Email limits may apply based on your plan</li><li>Limits may also depend on your email provider (e.g., Gmail quotas)</li></ul>
          </Section>

          <Section title="4. Payments & Plans">
            <ul className="list-disc pl-6 space-y-1">
              <li>Paid plans are billed as described on the platform</li>
              <li>No refunds unless stated otherwise</li>
              <li>We may change pricing with notice</li>
            </ul>
          </Section>

          <Section title="5. Account Termination">
            <p>We may suspend or terminate accounts if:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Terms are violated</li><li>Abuse or misuse is detected</li></ul>
            <p className="mt-2">You may delete your account anytime.</p>
          </Section>

          <Section title="6. Intellectual Property">
            <ul className="list-disc pl-6 space-y-1"><li>Aplica owns the platform, design, and technology</li><li>You retain ownership of your content</li></ul>
          </Section>

          <Section title="7. Limitation of Liability">
            <p>Aplica is provided "as is."</p>
            <p className="mt-2">We are not liable for:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Job rejections</li><li>Email delivery issues</li><li>Third-party service failures</li></ul>
          </Section>

          <Section title="8. Changes to Terms">
            <p>We may update these terms. Continued use means acceptance.</p>
          </Section>

          <Section title="9. Contact">
            <p className="inline-flex items-center gap-2"><Mail className="h-4 w-4" /> <a href="mailto:aplica1410@gmail.com" className="text-[#0047FF] hover:underline">aplica1410@gmail.com</a></p>
          </Section>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-2xl font-display tracking-tight text-slate-900 mb-3">{title}</h2>
      <div className="text-slate-600">{children}</div>
    </section>
  );
}
